import { z } from 'zod'

/**
 * Where a tree video is in its life. Mirrors `TreeVideoStatus` in
 * prisma/schema.prisma.
 *
 * Richer than a document's PENDING/READY because video genuinely has more
 * states: Cloudflare Stream re-encodes every upload, which takes real time, and
 * it can refuse a file outright. Collapsing PROCESSING into PENDING_UPLOAD
 * would leave somebody staring at a tile that looks stuck when it is working,
 * and collapsing ERRORED into either would make a rejected file look like one
 * still on its way.
 */
export const TREE_VIDEO_STATUSES = [
  'PENDING_UPLOAD',
  'PROCESSING',
  'READY',
  'ERRORED',
] as const

export const treeVideoStatusSchema = z.enum(TREE_VIDEO_STATUSES)

export type TreeVideoStatus = z.infer<typeof treeVideoStatusSchema>

/**
 * Statuses that can still change, and so are worth re-asking Stream about.
 *
 * A subset of `TREE_VIDEO_STATUSES`, named here so a renamed status fails
 * this file instead of leaving the poller watching a status that no longer
 * exists.
 */
export const UNSETTLED_TREE_VIDEO_STATUSES = [
  'PENDING_UPLOAD',
  'PROCESSING',
] as const satisfies readonly TreeVideoStatus[]
